import axios from 'axios';

export function fetchAffiliates(payload) {
    return axios.get('/affiliates/' + payload);
}
